import router from "./router/index.js";
import { isMobile } from "./utils";
import { pcRoutes, mobileRoutes } from "./router";

// 判断当前设备的型号从而改变当前路由
console.log(router);
router.addRoute(isMobile() ? mobileRoutes[0] : pcRoutes[0]);
console.log(router);
